import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { OfficeProfileResult } from "@/models/api/administration/servicesAndAttributes/ServiceTypeExportConfiguration";

export class ExportConfigurationOfficeProfile {
  @Expose()
  @IsString()
  accountNumber!: string;
  @Expose()
  @IsNumber()
  officeProfileId!: number;
}

export class TemporaryExportConfigurationOfficeProfile extends ExportConfigurationOfficeProfile {
  name!: string;
}

export class NewExportConfiguration {
  @Expose()
  @IsString()
  accountNumber!: string; //prefix
  @Expose()
  @IsOptional()
  @IsString()
  documentDescription!: string | null;
  @Expose()
  @IsOptional()
  @IsString()
  documentType!: string | null;
  @Expose()
  @IsOptional()
  @IsString()
  documentTypeCorrection!: string | null;
  @Expose()
  @IsNumber()
  exportConfigurationSettingId!: number | null;
  @Expose()
  @IsOptional()
  @IsString()
  register!: string | null;
  @Expose()
  @IsOptional()
  @IsString()
  registerCorrection!: string | null;
  @Expose()
  @IsString()
  serviceDescription!: string;
  @Expose()
  @IsOptional()
  @IsNumber()
  domesticTransactionTypeId!: number | null;
  @Expose()
  @IsOptional()
  @IsNumber()
  inEUTransactionTypeId!: number | null;
  @Expose()
  @IsOptional()
  @IsNumber()
  outEUTransactionTypeId!: number | null;
  @Expose()
  @Type(() => ExportConfigurationOfficeProfile)
  @IsArray()
  @ValidateNested()
  exportConfigurationOfficeProfiles!: Array<ExportConfigurationOfficeProfile>;
  temporaryExportConfigurationOfficeProfiles!: Array<TemporaryExportConfigurationOfficeProfile> | undefined;

  constructor(officeProfiles: Array<OfficeProfileResult> = [], serviceDescription = "") {
    this.accountNumber = "";
    this.documentDescription = "";
    this.documentType = "";
    this.documentTypeCorrection = "";
    this.exportConfigurationSettingId = null;
    this.register = "";
    this.registerCorrection = "";
    this.serviceDescription = serviceDescription;
    this.domesticTransactionTypeId = 1;
    this.inEUTransactionTypeId = 1;
    this.outEUTransactionTypeId = 1;
    this.exportConfigurationOfficeProfiles = officeProfiles.map(
      (v) => ({ officeProfileId: v.id, accountNumber: "" } as ExportConfigurationOfficeProfile)
    );
    this.createTemporaryExportConfigurationOfficeProfiles(officeProfiles);
  }

  createTemporaryExportConfigurationOfficeProfiles(officeProfiles: Array<OfficeProfileResult>): void {
    this.temporaryExportConfigurationOfficeProfiles = officeProfiles.map((v) => {
      let value = this.exportConfigurationOfficeProfiles.find((e) => e.officeProfileId === v.id)?.accountNumber;
      if (typeof value === "undefined") value = "";
      return {
        name: v.name,
        officeProfileId: v.id,
        accountNumber: value,
      };
    });
  }

  temporaryExportConfigurationOfficeProfilesToExportConfigurationProfiles(): void {
    if (this.temporaryExportConfigurationOfficeProfiles !== undefined)
      this.exportConfigurationOfficeProfiles = this.temporaryExportConfigurationOfficeProfiles
        .filter((v) => v.accountNumber !== "" && v.accountNumber !== null)
        .map((v) => ({ officeProfileId: v.officeProfileId, accountNumber: v.accountNumber }));
  }
}
